import { ObjectEntityFragment } from '../../api/fragments/generated/ObjectEntity.fragment';
import { Role } from 'generated/graphql';
import { userFullName } from 'utils/helpers/userFullName';

export interface ResponsibleUser {
  id: string;
  name: string;
  role: Role;
}

/**
 * Получает список бригадиров из объекта
 * @param object Объект типа ObjectEntityFragment
 * @returns Массив бригадиров
 */
export const getForemen = (object: ObjectEntityFragment): ResponsibleUser[] => {
  if (!object.responsibleUsers) return [];

  return object.responsibleUsers
    .filter(user => user.role === Role.Foreman)
    .map(user => ({
      id: user.id,
      name: userFullName(user),
      role: user.role,
    }));
};

/**
 * Получает список супервайзеров из объекта
 * @param object Объект типа ObjectEntityFragment
 * @returns Массив супервайзеров
 */
export const getSupervisors = (object: ObjectEntityFragment): ResponsibleUser[] => {
  if (!object.responsibleUsers) return [];

  return object.responsibleUsers
    .filter(user => user.role === Role.Supervisor)
    .map(user => ({
      id: user.id,
      name: userFullName(user),
      role: user.role,
    }));
};

/**
 * Получает список всех ответственных пользователей из объекта
 * @param object Объект типа ObjectEntityFragment
 * @returns Массив всех ответственных пользователей
 */
export const getAllResponsibleUsers = (object: ObjectEntityFragment): ResponsibleUser[] => {
  if (!object.responsibleUsers) return [];

  return object.responsibleUsers.map(user => ({
    id: user.id,
    name: userFullName(user),
    role: user.role,
  }));
};

/**
 * Получает список ответственных пользователей по указанной роли
 * @param object Объект типа ObjectEntityFragment
 * @param role Роль пользователей
 * @returns Массив пользователей с указанной ролью
 */
export const getResponsibleUsersByRole = (object: ObjectEntityFragment, role: Role): ResponsibleUser[] => {
  if (!object.responsibleUsers) return [];

  return object.responsibleUsers
    .filter(user => user.role === role)
    .map(user => ({
      id: user.id,
      name: `${user.firstname} ${user.lastname}${user.patronymic ? ` ${user.patronymic}` : ''}`,
      role: user.role,
    }));
};
